import React, { useState, useEffect, useRef } from 'react';
import LeaveConfigurationController from "../Controllers/LeaveConfigurationController";
import Input from '../../Components/Input'
import Dropdown from '../../Components/Dropdown'
import DateInput from '../../Components/DateInput';
import Loader from '../../Components/Loader';
import LoadingSkeleton from '../../Components/LoadingSkeleton'

const LeaveConfigurationScreen = ({ leaveConfigurationsList, leaveConfigurationListLoading, leaveConfigurationListError, onRefresh }) => {
    const {
        handleChange,
        timeOptions,
        setFields,
        fields,
        handleAddLeaveConfiguration,
        leaveConfigurationSuccess,
        leaveConfigurationError,
        leaveConfigurationLoading,
        errors,
        clearFields
    } = LeaveConfigurationController(leaveConfigurationsList, onRefresh);
    console.log("error fields in leave config", errors)

    // Toggle function for dropdown visibility
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Update Week Off options based on selected Working Days
    useEffect(() => {
        const workingDaysField = fields.find(f => f.label === 'Working Days');
        const workingDays = (workingDaysField?.value || []).map(d => d.value);

        const weekOffOptions = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
            .filter(day => !workingDays.includes(day))
            .map(day => ({ label: day, value: day }));

        const updatedFields = fields.map(field => {
            if (field?.label === 'Week Off') {
                return { ...field, options: weekOffOptions };
            }
            return field;
        });

        setFields(updatedFields);
    }, [fields.find(f => f.label === 'Working Days')?.value]);


    return (
        // <div style={styles.container}>
        <>
            <h2 style={styles.title}>Leave Configuration</h2>
            {fields?.map((field, index) => {
                const errorMessage = errors[field.key];
                return (
                    <div key={index} style={styles.field}>
                        <label style={styles.label}>{field?.label}</label>
                        {leaveConfigurationListLoading ? (
                            <LoadingSkeleton width="25%" height="35px" />
                        ) : (
                            <>
                                {/* Multi-select dropdown */}
                                {field.type === 'multiDropdown' && (
                                    <Dropdown
                                        isMulti
                                        value={field.value}
                                        onChange={(value) => handleChange(index, 'multiDropdown', value)}
                                        options={field.options}
                                        ref={(el) => (dropdownRefs.current[field?.label] = el)}
                                        isOpen={openDropdown === field?.label}
                                        toggleDropdown={() => toggleDropdown(field?.label)}
                                        searchBoxWidth={200}
                                        errorMessage={errorMessage}
                                        top='100%'
                                        disabledSelect={true}
                                    />
                                )}
                                {field.type === 'dropdown' && (
                                    <Dropdown
                                        value={field.value}
                                        onChange={(value) => handleChange(index, 'dropdown', value)}
                                        options={field.options}
                                        ref={(el) => (dropdownRefs.current[field?.label] = el)}
                                        isOpen={openDropdown === field?.label}
                                        toggleDropdown={() => toggleDropdown(field?.label)}
                                        searchBoxWidth={200}
                                        errorMessage={errorMessage}
                                        top='100%'
                                        disabledSelect={true}
                                    />
                                )}

                                {/* Time dropdown */}
                                {field.type === 'timeDropdown' && (
                                    <div style={styles.timeRange}>
                                        <Dropdown
                                            value={field.value.start}
                                            onChange={(val) =>
                                                handleChange(index, 'time', { start: val, end: field.value.end })
                                            }
                                            options={timeOptions}
                                            ref={(el) => (dropdownRefs.current[field?.label + ' Start'] = el)}
                                            isOpen={openDropdown === field?.label + ' Start'}
                                            toggleDropdown={() => toggleDropdown(field?.label + ' Start')}
                                            searchBoxWidth={100}
                                            errorMessage={errorMessage}
                                            top='100%'
                                            disabledSelect={true}
                                        />
                                        <span style={{ marginTop: '15px' }}> - </span>
                                        <Dropdown
                                            value={field.value.end}
                                            onChange={(val) =>
                                                handleChange(index, 'time', { start: field.value.start, end: val })
                                            }
                                            options={timeOptions}
                                            ref={(el) => (dropdownRefs.current[field?.label + ' End'] = el)}
                                            isOpen={openDropdown === field?.label + ' End'}
                                            toggleDropdown={() => toggleDropdown(field?.label + ' End')}
                                            searchBoxWidth={100}
                                            errorMessage={errorMessage}
                                            top='100%'
                                            disabledSelect={true}
                                        />
                                    </div>
                                )}

                                {/* Date input */}
                                {field.type === 'date' && (
                                    <div>
                                        <DateInput
                                            value={field.value}
                                            onChange={(e) => handleChange(index, 'date', e.target.value)}
                                            width="200px"
                                            errorMessage={errorMessage}
                                        />
                                    </div>
                                )}

                                {/* Numeric input */}
                                {field.type === 'number' && (
                                    <Input
                                        value={field.value}
                                        onChange={(e) => handleChange(index, 'number', e.target.value)}
                                        type="number"
                                        min="0"
                                        errorMessage={errorMessage}
                                        searchBoxWidth={200}
                                    />
                                )}

                                {/* Text input */}
                                {field.type === 'text' && (
                                    <Input
                                        value={field.value}
                                        onChange={(e) => handleChange(index, 'text', e.target.value)}
                                        type="text"
                                        errorMessage={errorMessage}
                                        searchBoxWidth={200}
                                    />
                                )}
                            </>
                        )}
                    </div>
                );
            })}

            <hr className="footer-divider" />
            <div className="button-container" style={{ gap: "10px" }}>
                <button className="add-client-button"
                    style={{
                        ...styles.updateButton, paddingLeft: 30, paddingRight: 30, opacity: leaveConfigurationLoading || leaveConfigurationListLoading ? 0.5 : 1, // Reduce opacity when loading
                        cursor: leaveConfigurationLoading || leaveConfigurationListLoading ? 'not-allowed' : 'pointer', gap: '10px',
                    }} onClick={handleAddLeaveConfiguration}>
                    <span>Update</span>
                    {(leaveConfigurationLoading || leaveConfigurationListLoading) && (
                        <Loader loading={leaveConfigurationLoading || leaveConfigurationListLoading} color={'var(--background-color)'} size="small" />
                    )}</button>
                <button style={styles.cancelButton} onClick={clearFields}>Cancel</button>
                {leaveConfigurationSuccess && <div className="list-success-msg">{leaveConfigurationSuccess} </div>}
                {leaveConfigurationError && <div className="list-error-msg">{leaveConfigurationError} </div>}
                {leaveConfigurationListError && <div className="list-error-msg">{leaveConfigurationListError} </div>}
            </div>
        </>
        // </div>

    )

}

const styles = {
    container: {
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        maxWidth: '600px',
        margin: 'auto',
    },
    title: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Roboto',
        fontWeight: '500',
    },
    field: {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        marginTop: "10px",
    },
    label: {
        flex: "0 0 220px", // Ensures all labels are the same width
        color: 'black',
        fontSize: 14,
        fontFamily: 'Roboto',
        fontWeight: '400',
    },
    timeRange: {
        display: 'flex',
        gap: '5px',
    },
    cancelButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    }
};

export default LeaveConfigurationScreen;